<template>
    <div class="flex-box container_content" v-loading="loading">
        <div class="tree">
            <treeMenu
                treeWidth="250px"
                style="width: 100%"
                ref="treeMenu"
                initId="0"
                :isEdit="true"
                loadStyle="staticLoad"
                @nodeClick="nodeId"
                :showBox="false"
            ></treeMenu>
        </div>
        <div class="flex-1 pt20 pb20 pl10 pr10" style="width: 0">
            <Sift ref="needSift" :sift-data="siftData" v-if="siftData.length" @change="initPage">
                <el-col class="flex-box al-c" :span="8">
                    <!-- <div class="flex-box al-c mb10">
                        <span class="mr10 tx-r" style="width: 70px;">部门</span>
                        <el-input
                            v-model="dep.name"
                            @focus="showDialog"
                            :readonly="true"
                            placeholder="请选择部门"
                        ></el-input>
                    </div> -->
                    <el-button class="mb10 ml10" type="primary" @click="initPage">查询</el-button>
                    <el-button class="mb10 ml10" type="primary" @click="addOrEditUser('add')" v-if="userData.routerData.includes('sys_user_add') || isAdmin">新增</el-button>
                    <el-button class="mb10 ml10" type="primary" @click="downloadExcel" icon="el-icon-bottom" v-if="userData.routerData.includes('sys_user_exp') || isAdmin">导出</el-button>
                    <el-button class="mb10 ml10" type="danger" @click="deleteUsers" v-if="userData.routerData.includes('sys_user_del') || isAdmin">批量删除</el-button>
                </el-col>
            </Sift>

            <el-table
                class="w100 mt20 table"
                header-row-class-name="table-head"
                row-class-name="cu-p"
                stripe
                :data="list"
                max-height="calc(100vh - 260px)"
                height="100%"
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column align="center" label="序号" width="50px">
                    <template
                        slot-scope="scope"
                    >{{ pageNum * pageSize - pageSize + scope.$index + 1 }}</template>
                </el-table-column>
                <el-table-column align="center" prop="username" label="用户名"></el-table-column>
                <el-table-column align="center" prop="name" label="姓名" width="100"></el-table-column>
                <el-table-column align="center" prop="deptName" label="部门" >
                    <template slot-scope="scope">
                        <span>{{scope.row.deptName.slice(0, -1)}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="角色">
                    <template
                        slot-scope="scope"
                    >{{ scope.row.roleList | filterRoleName }}</template>
                </el-table-column>
                <el-table-column align="center" label="创建时间" width="150">
                    <template
                        slot-scope="scope"
                    >{{ scope.row.createTime | filterDate('yyyy-MM-dd hh:mm') }}</template>
                </el-table-column>
                <el-table-column align="center" prop="refuseIP" label="操作" width="200">
                    <template slot-scope="scope">
                        <div class="to-use">
                            <span class="info" @click="passwordFn(scope.row.userId, scope.row.username)">初始化密码</span>
                            <span
                                class="info"
                                @click="addOrEditUser('edit',scope.row)"
                                v-if="userData.routerData.includes('sys_user_edit') || isAdmin"
                            >编辑</span>
                            <span
                                class="danger"
                                @click="deleteUser(scope.row)"
                                v-if="userData.routerData.includes('sys_user_del') || isAdmin"
                            >删除</span>
                        </div>
                    </template>
                </el-table-column>
                 <el-table-column align="center"  label="特殊账户" width="80">
                    <template slot-scope="{row}">
                        <div class="to-use">
                            <!-- <span class="info">调入</span> -->
                            <span class="info" @click="block(row)" v-if="row.specialFlag == 1">停用</span>
                            <span class="info" @click="toEnable(row)" v-if="row.specialFlag == 0">启用</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 新增弹窗 -->
            <el-dialog
                :modal="false"
                class="selfModal"
                :close-on-click-modal="false"
                v-if="showAddModal"
                :visible.sync="showAddModal"
                :title="title"
                width="800px"
                @close="handleReset('formValidate')"
            >
                <el-tabs v-model="activeTab" @tab-click="tabClick">
                    <el-tab-pane :label="title==='新增'?'单个新增':'编辑账号'" name="single">
                        <div style="padding-right: 20px">
                            <el-form
                                :model="formValidate"
                                :rules="ruleValidate"
                                ref="formValidate"
                                label-width="100px"
                                class="demo-ruleForm"
                            >
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="用户名" prop="username">
                                            <el-input :disabled="oper != 'add'" v-model="formValidate.username" placeholder="请输入用户名"></el-input>
                                        </el-form-item>
                                        <el-form-item label="姓名" prop="name">
                                            <el-input v-model="formValidate.name" ></el-input>
                                        </el-form-item>
                                        <el-form-item label="用户类型" prop="type" >
                                            <el-select v-model="formValidate.type" placeholder="请选择角色类型" style="width: 100%" @change="roleTypeChange">
                                                <el-option label="学生" :value="0"></el-option>
                                                <el-option label="教师" :value="1"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="用户角色" prop="roleIds" >
                                            <el-select v-model="formValidate.roleIds" multiple filterable placeholder="可输入搜索角色" style="width: 100%" @focus="roleSelectFocus">
                                                <template v-if="formValidate.type===1">
                                                    <el-option
                                                        v-for="item in tRoleList"
                                                        :key="item.roleId"
                                                        :label="item.roleName"
                                                        :value="item.roleId">
                                                    </el-option>
                                                </template>
                                                <template v-if="formValidate.type===0">
                                                    <el-option
                                                        v-for="item in sRoleList"
                                                        :key="item.roleId"
                                                        :label="item.roleName"
                                                        :value="item.roleId">
                                                    </el-option>
                                                </template>
                                            </el-select>
                                        </el-form-item>
                                        <!-- <el-form-item label="角色" prop="roleIds" >
                                            <el-select v-model="formValidate.roleIds" multiple filterable placeholder="可输入搜索角色" style="width: 100%">
                                                <el-option
                                                    v-for="item in roleList"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item> -->
                                        <el-form-item label="部门" prop="deptName">
                                            <el-col :span="20">
                                                <el-input disabled v-model="formValidate.deptName"></el-input>
                                            </el-col>
                                            <el-col :span="4" style="display: flex;justify-content: flex-end">
                                                <el-button @click="changeUserDept" icon="el-icon-menu"></el-button>
                                            </el-col>
                                        </el-form-item>
                                        <el-form-item label="手机号" prop="phone">
                                            <el-input type="text" v-model="formValidate.phone" placeholder="请输入手机号"></el-input>
                                        </el-form-item>
                                        <!-- <el-form-item label="密码" prop="password" v-if="title === '新增' ">
                                            <el-input
                                                type="password"
                                                placeholder="请输入密码"
                                                autocomplete="new-password"
                                                v-model="formValidate.password"
                                            ></el-input>
                                        </el-form-item> -->
                                        <el-form-item label="性别" prop="sex" >
                                            <el-radio-group v-model="formValidate.sex">
                                                <el-radio :label="'0'">女</el-radio>
                                                <el-radio :label="'1'">男</el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                        <el-form-item label="出生年月" prop="birthDate" >
                                            <el-date-picker
                                                v-model="formValidate.birthDate"
                                                value-format="yyyy-MM"
                                                type="month"
                                                placeholder="选择出生年月"
                                                @change="dateChange('birthDate')">
                                            </el-date-picker>
                                        </el-form-item>
                                        <el-form-item :label="formValidate.type?'入职时间':'入学时间'" prop="admissionDate" >
                                            <el-date-picker
                                                v-model="formValidate.admissionDate"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                placeholder="选择日期"
                                                @change="dateChange('admissionDate')">
                                            </el-date-picker>
                                        </el-form-item>
                                        <!-- <el-form-item label="创建时间" v-if="title === '编辑' ">
                                            <el-input disabled v-model="formValidate.createTime"></el-input>
                                        </el-form-item> -->
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="标签" prop="labelIds" >
                                            <el-select v-model="formValidate.labelIds" multiple filterable placeholder="可输入搜索标签" style="width: 100%">
                                                <el-option
                                                    v-for="item in labelList"
                                                    :key="item.labelId"
                                                    :label="item.labelName"
                                                    :value="item.labelId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="英文名" prop="enName" >
                                            <el-input
                                                placeholder="请输入英文名"
                                                v-model="formValidate.enName"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item label="身份证" prop="identityCard" >
                                            <el-input
                                                placeholder="请输入身份证"
                                                v-model="formValidate.identityCard"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item label="邮箱" prop="email" >
                                            <el-input
                                                placeholder="请输入邮箱"
                                                v-model="formValidate.email"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item label="微信" prop="wxNo" >
                                            <el-input
                                                placeholder="请输入微信"
                                                v-model="formValidate.wxNo"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item label="联系地址" prop="address" >
                                            <el-input
                                                placeholder="请输入联系地址"
                                                v-model="formValidate.address"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item label="邮编" prop="postcode" >
                                            <el-input
                                                placeholder="请输入邮编"
                                                v-model="formValidate.postcode"
                                            ></el-input>
                                        </el-form-item>
                                        <el-form-item label="家庭电话" prop="homePhone" >
                                            <el-input
                                                placeholder="请输入家庭电话"
                                                v-model="formValidate.homePhone"
                                            ></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="批量新增" name="multiple" v-if="oper === 'add'">
                        <ImportAndDownloadExcel ref="importAndDownloadExcel" :uplodData="uplodData" downloadType="user"/>
                    </el-tab-pane>
                </el-tabs>
                
                <el-dialog
                    class="deptDialog"
                    :close-on-click-modal="false"
                    :visible.sync="chooseDepartment.state"
                    width="480px"
                    title="部门选择"
                    :modal="false"
                >
                    <!--<p slot="title">
                                <span>部门选择</span>
                    </p>-->
                    <div class="modaltree">
                        <treeMenu
                            ref="treeMenu"
                            initId="0"
                            :showArrow="false"
                            :showShadow="false"
                            :isEdit="false"
                            loadStyle="staticLoad"
                            @nodeClick="nodeIdModal"
                            :showBox="false"
                        ></treeMenu>
                    </div>
                    <span slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="depTreeBtn('1')">确 定</el-button>
                    </span>
                </el-dialog>
                <span slot="footer" class="dialog-footer">
                    <el-button
                        type="primary"
                        :disabled="submitBtn"
                        @click="handleSubmit('formValidate')"
                        size="small"
                    >确 认</el-button>
                    <el-button
                        @click="handleReset('formValidate')"
                        style="margin-left: 8px"
                        size="small"
                    >关 闭</el-button>
                </span>
            </el-dialog>

            <div class="mt20 flex-box">
                <div class="flex-1"></div>
                <el-pagination
                    background
                    @size-change="changeSize"
                    @current-change="changePage"
                    :current-page="pageNum"
                    :page-sizes="[10, 20, 30, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                ></el-pagination>
            </div>

            <!-- <DepTree ref="DetTree" :propData="propData" @backFn="setDepData" /> -->
        </div>
        <Enable :enable="enable" @close="closeEnable"/>
        <Blockup :blockup = "blockup" @close = "closeBlockUp"/>
    </div>
</template>

<script>
import Sift from "@/components/sift/Sift";
import treeMenu from '@/components/treeMenu/index.vue'
// import DepTree from "@/components/management/user/DepTree";
import { getListTableUrl, insertUrl, updateUrl, 
deleteUser, initUserPassword, deleteUsers,endUsing } from "@/api/management/user";
import { getList } from "@/api/system/role";
import { getAllLabelList } from "@/api/managementCenter/labelManage";
import {mapGetters} from "vuex";
import moment from "moment";
import ImportAndDownloadExcel from '@/components/dialog/common/importAndDownloadExcel'
import {getRoleTableData} from "@/api/system/role";
import {excelExport} from '@/api/importAndExport/excelApi';
// 调用得弹框
import Enable from "./enable.vue"
// 停用弹框
import Blockup from "./blockup.vue"
export default {
    name: "Serve",
    components: {
        Sift,
        // DepTree,
        treeMenu,
        ImportAndDownloadExcel,
        Enable,
        Blockup
    },
    props: [],
    data() {
        return {
            // 启用弹框数据
            enable:{
                state:false,
                title:"",
                tableItem:[],//启用或者调入得列表项目，
                info:"",
                status:"",
                userId:""
            },
            // 停用弹框数据
            blockup:{
                state:false,
                userId:""
            },
            baseUrl: process.env.BASE_URL,
            uplodData: {
                type: 'user',
            },
            loading: false,
            tabLoading: false,
            siftData: [],
            roleList: [],
            tRoleList: [],
            sRoleList: [],
            list: [],
            pageNum: 1,
            pageSize: 10,
            total: 0,
            propData: [],
            labelList: [],
            dep: {
                id: "",
                name: "",
                parentId: "",
            },
            showAddModal: false,
            oper: '', // 控制新增和编辑
            title: '新增',
            chooseDepartment: {
              state: false,
              data: {},
              showBox: false
            },
            submitBtn: false,
            activeTab: 'single',
            formValidate: {
                userId: "",
                name: "",
                username: "",
                phone: "",
                userCode: "",
                deptName: "",
                deptId: null,
                sort: 0,
                creator: "", // 创建者
                password: "",
                vpassword: "",
                createTime: "", // 创建时间
                updateTime: "", // 修改时间
                type: "", // 类型
                charge: false,
                chargeman: "", //负责人列表
                chargeDeptIds: [], // 负责部门id
                roleIds: [],   // 角色

                sex: '0',
                birthDate: '',
                labelIds: [],  // 标签
                enName: '',  // 英文名
                identityCard: '',  // 身份证
                postcode: '',  // 邮编
                wxNo: '',  // 微信
                address: '',  // 联系地址
                email: '',  // 邮箱
                homePhone: '',  // 家庭电话
                admissionDate: '',
            },
            options: {
              expiredFlag: [
                  {label: "全部", value: ""},
                  {label: "在职", value: "0"},
                  {label: "离职", value: "1"},
              ],
              roleDatas: [
                  {label: "学生", value: "0"},
                  {label: "教师", value: "1"},
                  {label: "教职工", value: "2"},
              ],
              stateDatas: [
                  {label: "有效", value: "0"},
                  {label: "无效", value: "1"}
              ],
              singleType: [
                  {label: "全部", value: ""},
                  {label: "教师", value: "1"},
                  {label: "教职工", value: "2"},
              ],
              singleTypeTwo: [
                  {label: "教师", value: "1"},
                  {label: "教职工", value: "2"},
              ]
            },
            ruleValidate: {
            identityCard: [
                {pattern: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '请填正确填写身份证号', trigger: 'blur'},
              ],
            admissionDate: [
                {required: true, message: '请填选择', trigger: 'blur'},
              ],
            birthDate: [
                {required: true, message: '请填选择出生年月', trigger: 'blur'},
              ],
            sex: [
                {required: true, message: '请填选择性别', trigger: 'blur'},
              ],
              username: [
                {
                    type: "string",
                    required: true,
                    trigger: 'blur',
                    validator: (rule, value, callback) => {
                        if (this.oper === "add") {
                            if (value === '') {
                                callback("用户名不能为空！");
                            } else {
                                // validateNameUrl(value).then(res => {
                                //     if (res.data.data) {
                                //         callback("用户名已存在！");
                                //     } else {
                                //         callback();
                                //     }
                                // })
                              callback();
                            }
                        } else {
                            callback();
                        }


                    }
                },
                {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'},
                {pattern: /^[0-9a-zA-Z_-]+$/, message: "只能输入大小写字母或数字或数字字母组合，可包含'-''_'", trigger: 'blur'}

              ],
              name: [
                {required: true, message: '请填写姓名', trigger: 'blur'},
                {max: 10, message: '长度在10个字符以内', trigger: 'blur'}
              ],
              deptName: [
                {required: true, message: '请选择部门', trigger: 'blur'},
              ],
              roleIds: [
                {required: true, message: '请选择角色', trigger: 'blur'},
              ],
              type: [
                { required: true, message: '请选择类型', trigger: 'change' }                    ],
              password: [
                {required: true, message: '密码不能为空', trigger: 'blur'},
                {min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur'}
              ],
              phone: [
                {required: true, message: '手机号不能为空', trigger: 'blur'},
                {pattern:  /^1[3|4|5|7|8|9][0-9]\d{8}$/, message: '请输入正确的手机号'},
              ],
              vpassowrd: [
                  {
                      type: "string",
                      required: true,
                      trigger: 'blur',

                      validator: (rule, value, callback) => {

                          if (this.formValidate.vpassword == this.formValidate.password) {
                              callback();
                          } else {
                              callback("验证密码与密码不一致");
                          }
                      }
                  }
              ]
          },
          selections: [],
        };
    },
    computed: {
        ...mapGetters([
            "chooseDept",
            "userData",
        ]),
    },
    created() {},
    mounted() {
        this.fetchSiftData();
    },
    destroyed() {},
    methods: {
        // 启用
        toEnable(row){
            this.enable.state = true
            this.enable.title = "启用特殊账户"
            this.enable.info = "启用"
            this.enable.status = 1 //1表示启用
            this.enable.userId = row.userId
            this.enable.tableItem = [
                {
                    label:"账号",
                    prop:"userName"
                },
                {
                    label:"岗位",
                    prop:"specialName"
                },
                 {
                    label:"当前使用人",
                    prop:"name"
                },
                {
                    label:"部门",
                    prop:"deptName"
                },
            ]
        },
        closeEnable(status){
            this.enable.state = false
            if(status){
            this.getListFn()
            }
        },
        // 停用
        block(row){
        this.blockup.userId = row.userId
        this.blockup.state = true
        },
        closeBlockUp(status){
        this.blockup.state = false
        if(status){
            this.getListFn()
        }
        },
        isAdmin(){
            return (this.userData.roleCodes||[]).includes('ROLE_ADMIN')
        },
        downloadExcel(){
            this.$DownLoad(
                excelExport('user'),
                null,
                res => {
                    if (res.status == 200) {
                        // this.$message.success("开始下载");
                    } else {
                        this.$alert("下载出错,请稍后重试", "提示", {
                            confirmButtonText: "确定",
                            type: "warning"
                        });
                    }
                },
                error => {
                    this.$alert(error, "提示", {
                        confirmButtonText: "确定",
                        type: "warning"
                    });
                }
            );
        },
        handleSelectionChange(selection){
            this.selections = selection;
        },
        deleteUsers(){
            if(!this.selections.length){
                this.$message.warning('请先选择用户')
                return
            }
            const selectionIds = this.selections.map(item => item.userId)
            const ids = selectionIds.join(',')
            this.$confirm('确认删除选中的所有用户吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteUsers({ ids }).then((res) => {
                    if (res.data.code == 0) {
                        this.$message.success("删除成功");
                        this.initPage()
                    }else {
                        this.$message.error(res.data.msg)
                    }
                })
            })
        },
        tabClick(){
            this.resetImp()
        },
        resetImp() {
            if(this.$refs.importAndDownloadExcel){
                this.$refs.importAndDownloadExcel.reset()
            }
        },
        nodeId(data){
            this.dep.id = data.id
            this.initPage()
        },
        // 更换部门名称弹框
        changeUserDept() {
          this.chooseDepartment.data = {};
          this.chooseDepartment.chooseBox = false;
          this.chooseDepartment.state = true;
        },
        nodeIdModal(tree) {
          console.log(tree)
          this.chooseDepartment.data = tree
        },
        // 搜索框组件数据
        fetchSiftData() {
            this.loading = true;
            this.getRoleList();  // 请求角色列表
            this.getUserTree();  // 请求部门树

            setTimeout(() => {
                this.siftData = [
                    // {
                    //     type: "text",
                    //     key: "name",
                    //     label: "姓名",
                    //     placeholder: "",
                    //     default: "",
                    // },
                    {
                        type: "text",
                        key: "username",
                        label: "姓名",
                        placeholder: "",
                        default: "",
                    },
                    {
                        type: "select",
                        key: "roleId",
                        label: "角色",
                        placeholder: "",
                        default: "",
                        data: this.roleList,
                    },
                ];
                this.loading = false;
                this.$nextTick(() => {
                    this.initPage();
                });
            }, 500);
        },

        // 获取角色
        getRoleList () {
          getList()
          .then( ({ data }) => {
            if ( data.code === 0 ) {
              data.data.forEach( e => {
                this.roleList.push({ value: String(e.roleId), label: e.roleName });
              });
            }else {
                this.$message.error(data.msg)
            }
          })
          .catch(() => {})
        },

        // 部门树
        getUserTree () {
        //   this.$http.get( "/web/depList" )
        //   .then( ({ data }) => {
        //     if ( data.resCode === 0 ) {
        //       this.propData = data.resData;
        //     }
        //   })
        //   .catch(() => {})
            this.propData = this.chooseDept
        },

        // 获取查询列表
        getListFn() {
            this.loading = true;
            let searchData = this.$refs.needSift.getValue();
            let data = {
                current: this.pageNum,
                size: this.pageSize,
                userName: searchData.username,
                roleId: searchData.roleId,
                deptId: this.dep.id,
            };

            getListTableUrl(data)
                .then(({ data }) => {
                    if (data.code === 0) {
                        this.list = data.data.records;
                        this.total = data.data.total;
                    }else {
                        this.$message.error(data.msg)
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },

        // 密码初始化
        passwordFn(id, name) {
            this.$confirm("是否确定初始化 " + name + " 密码?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.loading = true;
                    // 密码初始化
                    initUserPassword({username: name})
                        .then(({ data }) => {
                            if (data.code === 0) {
                                this.$message.success(
                                    name + " 密码初始化成功！"
                                );
                                this.getListFn();
                            }else {
                                this.$message.error(data.msg)
                            }
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                })
                .catch((err) => {
                    this.$message({ type: "info", message: "已取消初始化！" });
                });
        },

        // 显示弹框
        showDialog() {
            this.$refs.DetTree.dialogShow();
        },

        // // 设置选中的部门数据
        // setDepData(data) {
        //     this.dep.id = data ? data.id : '';
        //     this.dep.name = data ? data.name : '';
        //     this.initPage();
        // },

        // 默认页面数据
        initPage() {
            this.pageNum = 1;
            this.getListFn();
        },

        // 条数
        changeSize(value) {
            this.pageSize = value;
            this.getListFn();
        },
        // 上下页
        changePage(value) {
            this.pageNum = value;
            this.getListFn();
        },

        deleteUser(row){
            this.$confirm('确认删除用户：' + row.username + "？", '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteUser(row.userId).then((res) => {
                    if (res.data.code == 0) {
                        this.$message.success("删除成功");
                        this.getListFn()
                    }else {
                        this.$message.error(res.data.msg)
                    }
                })
            })
        },
        getRoleTableData(){
            getRoleTableData({current:1, size:100, type:0})
            .then(({data}) => {
                if(data.code==0){
                    this.tRoleList = data.data.records || []
                }else{
                    this.$message.error(data.msg)
                }
            })
            getRoleTableData({current:1, size:100, type:1})
            .then(({data}) => {
                if(data.code==0){
                    this.sRoleList = data.data.records || []
                }else{
                    this.$message.error(data.msg)
                }
            })
        },
        roleTypeChange(){
            this.formValidate.roleIds = []
        },
        roleSelectFocus(e){
            if(this.formValidate.type===''||this.formValidate.type===undefined){
                this.$message.warning('请先选择用户类型')
            }
        },
        addOrEditUser(type, params) {
            this.getAllLabelList()
            this.getRoleTableData()
          let that = this
          this.title = type === 'add' ? '新增' : '编辑';
          this.oper = type;
          if (type === 'edit') {
            this.formValidate.userId = params.userId;
            this.formValidate.username = params.username;
            this.formValidate.name = params.name;
            this.formValidate.deptName = params.deptName;
            this.formValidate.deptId = params.deptId;
            this.formValidate.phone = params.phone;
            this.formValidate.type = params.type
            this.formValidate.admissionDate = params.admissionDate
            this.formValidate.address = params.address
            this.formValidate.birthDate = params.birthDate
            this.formValidate.enName = params.enName
            this.formValidate.homePhone = params.homePhone
            this.formValidate.identityCard = params.identityCard
            this.formValidate.labelIds = params.labelList.map(item => item.labelId)
            this.formValidate.postcode = params.postcode
            this.formValidate.email = params.email
            this.formValidate.sex = params.sex
            this.formValidate.wxNo = params.wxNo
            // this.formValidate.createTime = params.createTime
            this.formValidate.roleIds = params.roleList.map(item => item.roleId)
          } else {

              this.formValidate.sort = 0;
              this.formValidate.password = '';
              this.formValidate.vpassword = '';
              // this.formValidate.deptName = this.deptTree.label;
              // this.formValidate.deptId = this.deptTree.id;
              this.formValidate.state = this.options.stateDatas[0].value;
              this.formValidate.createTime = '';

          }
          this.showAddModal = true
        },
        getAllLabelList(){
            getAllLabelList()
            .then(({data}) => {
                if(data.code == 0){
                    this.labelList = data.data;
                }else {
                    this.$message.error(data.msg)
                }
            })
        },
        // 新增-部门选择确认按钮
        depTreeBtn() {
          this.formValidate.deptId = this.chooseDepartment.data.id;
          this.formValidate.deptName = this.chooseDepartment.data.name;
          this.chooseDepartment.state = false
        },
        handleReset(){
            this.showAddModal = false;
            // this.$refs.formValidate.resetFields()
            this.formValidate = {
                userId: "",
                name: "",
                username: "",
                phone: "",
                userCode: "",
                deptName: "",
                deptId: null,
                sort: 0,
                creator: "", // 创建者
                password: "",
                vpassword: "",
                createTime: "", // 创建时间
                updateTime: "", // 修改时间
                type: "", // 类型
                charge: false,
                chargeman: "", //负责人列表
                chargeDeptIds: [], // 负责部门id
                roleIds: [],
                sex: 0,
                birthDate: '',
                labelIds: [],  // 标签
                enName: '',  // 英文名
                identityCard: '',  // 身份证
                postcode: '',  // 邮编
                wxNo: '',  // 微信
                address: '',  // 联系地址
                email: '',  // 邮箱
                homePhone: '',  // 家庭电话
                admissionDate: '', 
            };
            this.resetImp()
        },
        handleSubmit(name){
            if(this.activeTab==='multiple'){
                this.handleReset()
                return
            }
          var that = this;
          this.$refs[name].validate((valid) => {
            if (valid) {
              this.submitBtn = true
              var insertobj = {};
              insertobj.name = this.formValidate.name;
              insertobj.username = this.formValidate.username;
              insertobj.deptId = this.formValidate.deptId;
              insertobj.type = this.formValidate.type;
              insertobj.roleIds = this.formValidate.roleIds;
              insertobj.phone = this.formValidate.phone;
              insertobj.sex = this.formValidate.sex
                insertobj.birthDate = this.formValidate.birthDate
                insertobj.labelIds = this.formValidate.labelIds
                insertobj.enName = this.formValidate.enName
                insertobj.identityCard = this.formValidate.identityCard
                insertobj.postcode = this.formValidate.postcode
                insertobj.wxNo = this.formValidate.wxNo
                insertobj.address = this.formValidate.address
                insertobj.email = this.formValidate.email
                insertobj.homePhone = this.formValidate.homePhone
                insertobj.admissionDate = this.formValidate.admissionDate
                insertobj.roleList = this.formValidate.roleList;
              if (that.oper == "add") {
                //   insertobj.password = this.formValidate.password;
                  insertobj.password = `111111`;  // 默认密码
                  insertUrl(insertobj).then(res => {
                      this.submitBtn = false
                      if (res.data.code === 0) {
                          this.$message.success("用户新增成功");
                          this.getListFn()

                          this.$refs.formValidate.resetFields()
                            this.showAddModal = false;
                      }else {
                            this.$message.error(res.data.msg)
                        }
                  })
              } else {
                  insertobj.userId = this.formValidate.userId;
                  updateUrl(insertobj).then(res => {
                      this.submitBtn = false
                      if (res.data.code === 0) {
                          this.$message.success("用户编辑成功");
                          this.getListFn()
                            this.$refs.formValidate.resetFields()
                            this.showAddModal = false;
                      }else {
                            this.$message.error(res.data.msg)
                        }
                  })
              }
              
            }
          })
        },
        dateChange(name){
            if(name=="birthDate"&&this.formValidate.admissionDate){//入职时间
                if(this.formValidate.type){
                    if(this.formValidate.birthDate>this.formValidate.admissionDate){
                        this.$message.warning("出生年月不能晚于入职时间")
                        this.formValidate.birthDate=""
                        return
                    }
                }else{
                    if(this.formValidate.birthDate>this.formValidate.admissionDate){
                        this.$message.warning("出生年月不能晚于入学时间")
                        this.formValidate.birthDate=""
                        return
                    }
                }
            }
            if(name=="admissionDate"&&this.formValidate.birthDate){//入学时间
                if(this.formValidate.type){
                    if(this.formValidate.admissionDate<this.formValidate.birthDate){
                        this.$message.warning("入职时间不能早于出生年月")
                        this.formValidate.admissionDate=""
                        return
                    }
                }else{
                    if(this.formValidate.admissionDate<this.formValidate.birthDate){
                        this.$message.warning("入学时间不能早于出生年月")
                        this.formValidate.admissionDate=""
                        return
                    }
                }
            }
        }
    },
    watch: {},
    filters: {
        filterRoleName(val){
            if(!val){
                return ''
            }
            return val.map((item) => {
                return item.roleName
            }).join(',')
        }
    },
};
</script>

<style scoped lang="less">
.table-con {
    height: calc(100vh - 270px);
}

.to-use {
    width: 100%;
}

.to-use span {
    padding: 0 8px;
    display: inline-block;
}

.to-use .info {
    color: #409eff;
}

.to-use .danger {
    color: #f20;
}
.to-use .delete {
    color: #cdcdcd;
}

.to-use .info:hover {
    color: #336ab1;
}

.to-use .delete:hover {
    color: #606266;
}
// /deep/ .el-table__body-wrapper {
//     max-height: calc(100vh - 300px);
//     overflow-y: auto;
// }
.modaltree {
    max-height: 500px;
    overflow-y: auto;
}

.demo-ruleForm /deep/ .el-upload--text {
    width: 100%;
    height: 150px;
}
</style>
